module.exports = __webpack_public_path__ + "static/media/image-garota-na-ponte.37b94d48.svg";